import {
  Columns,
  Column,
  Stack,
  Heading,
  Text,
  Box,
} from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { CompanySearchBar } from '../companySearchBar/CompanySearchBar';

export function HomePageBanner() {
  const { t } = useTranslations(translations);

  return (
    <Columns
      space={{ mobile: 'none', tablet: 'xxlarge' }}
      alignY="center"
      collapseBelow="desktop"
    >
      <Column>
        <Stack space="large">
          <Heading level="1">{t('Find the right company for you')}</Heading>
          <Stack space="xxlarge">
            <Text size="large">
              {t(
                'Everything you need to know about a company, all in one place',
              )}
            </Text>
            <CompanySearchBar />
          </Stack>
        </Stack>
      </Column>
      <Column>
        <Box display={{ mobile: 'none', desktop: 'flex' }}>
          <img
            src="https://image-service-cdn.seek.com.au/20798a4e88889d8c6ddfd63f03816c6e1bb81e25/"
            alt="landing page image"
            width="100%"
          />
        </Box>
      </Column>
    </Columns>
  );
}
